export default "__VITE_ASSET__f34bf154__"